import { render } from "./TurnTimesView.vue?vue&type=template&id=4b7833be&scoped=true"
import script from "./TurnTimesView.vue?vue&type=script&lang=js"
export * from "./TurnTimesView.vue?vue&type=script&lang=js"

import "./TurnTimesView.vue?vue&type=style&index=0&id=4b7833be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7833be"]])

export default __exports__